<script>
  import RelatedProductCarousel from '@/components/Ecommerce/Products/RelatedProductCarousel.vue'

  export default {
    components: {
      RelatedProductCarousel
    },
    props: {
      products: {
        type: Array,
        required: true
      }
    }
  }
</script>

<template>
  <div v-if="products.length">
    <h4 class="px-4 mb-6 md:mt-12 md:mb-9 text-1xl md:px-0">
      Aanbevolen producten
    </h4>
    <RelatedProductCarousel :products="products" />
  </div>
</template>

<style scoped>

</style>
